import React from "react"
import styled from "styled-components"
import Img from "gatsby-image"
import Numbers from "./Numbers"
import { useStaticQuery, graphql } from "gatsby"
const getImage = graphql`
  {
    strapiAboutPageImages(name: { eq: "imageNumbers" }) {
      image {
        childImageSharp {
          fixed(width: 328) {
            ...GatsbyImageSharpFixed_tracedSVG
          }
        }
      }
    }
  }
`
const ServicesNumbers = ({lang}) => {
  const image = useStaticQuery(getImage)
  return (
    <Wraper>
      <div className="container">
        <div className="numbers">
          <Numbers lang={lang} />
        </div>

        <div className="imageNumber">
          <Img fixed={image.strapiAboutPageImages.image.childImageSharp.fixed} />
        </div>
      </div>
    </Wraper>
  )
}

export default ServicesNumbers

const Wraper = styled.section`
  padding: 50px 0;
  .container {
    display: flex;
    justify-content: flex-end;
    .numbers {
      margin-right: 5px;
    }
    .imageNumber {
      .gatsby-image-wrapper {
        height: 100% !important;
      }
      @media (max-width: 600px) {
        .gatsby-image-wrapper {
          width: 250px !important;
        }
      }
      @media (max-width: 500px) {
        .gatsby-image-wrapper {
          width: 200px !important;
        }
      }
      @media (max-width: 425px) {
        .gatsby-image-wrapper {
          width: 180px !important;
        }
      }
      @media (max-width: 380px) {
        .gatsby-image-wrapper {
          width: 160px !important;
        }
      }
      @media (max-width: 350px) {
        .gatsby-image-wrapper {
          width: 130px !important;
        }
      }
    }
  }
`
